module.exports = __webpack_public_path__ + "img/success-moto.942ebc49.svg";